// extracted by mini-css-extract-plugin
module.exports = {"displayCard":"styles_displayCard__Luj5R","footer":"styles_footer__2D5pe"};